@if (textContent$ | async) {
  <div
    class="text-with-side-image flex pr-large-t"
    [ngClass]="{
      'black-friday': isBlackFriday$ | async,
      'mr-large-b': noPadding$ | async,
      'mr-large-y': (noPadding$ | async) === false,
      'no-padding': noPadding$ | async,
      'pr-xlarge-t': (noPadding$ | async) === false,
      'pr-large-t': noPadding$ | async,
      'section-marker': showSectionMarker$ | async,
      'text-with-side-image--reversed': imageLeft,
    }"
  >
    <div class="text-with-side-image-article pr-xsmall-r">
      <cms-rich-text [content$]="textContent$" />
      @if (link$ | async) {
        <cms-link-block class="block pr-large-t" [content$]="link$" />
      }
    </div>
    <div
      class="text-with-side-image-image pr-xsmall-l flex overflow-hidden"
      [ngClass]="{
        'disable-cropping flex--align-start': (image$ | async)?.disableCropping,
        'flex--center': (noPadding$ | async) === false,
        'flex--start': noPadding$ | async,
        'pr-xxsmall-t': noPadding$ | async,
      }"
    >
      @if (image$ | async; as image) {
        <fin-content-image
          [imageData$]="image$"
          [aspectRatio$]="aspectRatio$"
          [fillParent]="isNewBrand() && !image.disableCropping"
        />
      }
    </div>
  </div>
}
